export * from './institution-data-store';
import * as _selectors from './selectors'
export const institutionSelectors = _selectors;